export function normalizeWebsiteUrl(value?: string) {
  const trimmed = value?.trim()
  if (!trimmed) return undefined
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed) && !/^https?:\/\//i.test(trimmed)) return undefined
  const candidate = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`
  try {
    const url = new URL(candidate)
    if ((url.protocol !== "http:" && url.protocol !== "https:") || !url.hostname) return undefined
    return url.toString()
  } catch {
    return undefined
  }
}

export function normalizeDriveFolderUrl(value?: string) {
  const trimmed = value?.trim()
  if (!trimmed) return undefined
  return /^https:\/\/drive\.google\.com\//i.test(trimmed) ? trimmed : undefined
}

export function websiteLabel(value: string) {
  try {
    return new URL(value).hostname.replace(/^www\./, "")
  } catch {
    return value
  }
}
